export const OverseasMissionPaths = {
  MANAGE_REQUEST_OVERSEAS_MISSION: 'overseas-mission',
  MANAGE_REQUEST_CREATE_OVERSEAS_MISSION: 'create',
  MANAGE_REQUEST_EDIT_OVERSEAS_MISSION: 'edit/:requestId',
};
